var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"mt-5 ml-2"},[_c('audio',{ref:"audio",attrs:{"src":_vm.src,"controls":""}},[_vm._v(" Your browser does not support this audio element. ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }